// QR Kiosk v2 — inline-SVG glyph map (ported verbatim from designer kiosk-shared.jsx `GD`).
// This is the ONLY icon source for the entire v2 tree. No lucide, no @mui/icons-material.
// Glyphs are 1.7px-stroke, currentColor; multi-path glyphs split their `d` on "|".
import React from "react";

// Verbatim path data — do not "clean up" the coordinates.
export const GD: Record<string, string> = {
  warn: "M12 4.6 L21 19.4 H3 Z|M12 10.4 v3.6|M12 16.8 v0.01",
  clip: "M8 5 h8 a2 2 0 0 1 2 2 v12 a2 2 0 0 1 -2 2 h-8 a2 2 0 0 1 -2 -2 v-12 a2 2 0 0 1 2 -2|M9 5 a3 3 0 0 1 6 0|M9.5 11 h5|M9.5 14.5 h5",
  book: "M4 6.5 C6.5 5 9.5 5 12 6.5 C14.5 5 17.5 5 20 6.5 V18.5 C17.5 17 14.5 17 12 18.5 C9.5 17 6.5 17 4 18.5 Z|M12 6.5 v12",
  info: "M12 21 a9 9 0 1 0 0 -18 a9 9 0 0 0 0 18|M12 11 v5|M12 7.6 v0.01",
  bldg: "M5 20 V6 a1.5 1.5 0 0 1 1.5 -1.5 h7 A1.5 1.5 0 0 1 15 6 v14|M15 10 h3 a1.5 1.5 0 0 1 1.5 1.5 V20|M3.5 20 h17|M8 8 h1.6|M11 8 h1.6|M8 11.5 h1.6|M11 11.5 h1.6|M8 15 h1.6|M11 15 h1.6",
  hist: "M4.5 12 a7.5 7.5 0 1 1 2.2 5.3|M4.5 12 v-4|M4.5 12 h4|M12 8.4 v4.1 l2.8 1.7",
  mic: "M12 4 a2.6 2.6 0 0 1 2.6 2.6 v5 a2.6 2.6 0 0 1 -5.2 0 v-5 A2.6 2.6 0 0 1 12 4|M6.8 11.8 a5.2 5.2 0 0 0 10.4 0|M12 17 v3",
  cam: "M4.5 8 h3 l1.6 -2.2 h5.8 L16.5 8 h3 A1.5 1.5 0 0 1 21 9.5 v8 A1.5 1.5 0 0 1 19.5 19 h-15 A1.5 1.5 0 0 1 3 17.5 v-8 A1.5 1.5 0 0 1 4.5 8|M12 16 a3 3 0 1 0 0 -6 a3 3 0 0 0 0 6",
  chev: "M9.5 6.5 L15 12 L9.5 17.5",
  lock: "M7 11 h10 a1.5 1.5 0 0 1 1.5 1.5 v6 A1.5 1.5 0 0 1 17 20 H7 a1.5 1.5 0 0 1 -1.5 -1.5 v-6 A1.5 1.5 0 0 1 7 11|M8.5 11 V8.5 a3.5 3.5 0 0 1 7 0 V11",
  phone: "M7.5 4.5 c0.6 0 2.1 2.6 2.1 3.3 0 0.9 -1.3 1.4 -1.3 2.2 0 1.2 2.5 4.5 4.5 5.2 0.8 0.3 1.4 -1 2.3 -1 0.7 0 3.4 1.5 3.4 2.1 0 1.6 -1.7 3.2 -3.4 3.2 -4.4 0 -10.6 -6 -10.6 -11.2 0 -1.9 1.5 -3.8 3 -3.8",
  copy: "M9 9 h9 a1.5 1.5 0 0 1 1.5 1.5 v9 A1.5 1.5 0 0 1 18 21 H9 a1.5 1.5 0 0 1 -1.5 -1.5 v-9 A1.5 1.5 0 0 1 9 9|M5.5 14.5 H5 a1.5 1.5 0 0 1 -1.5 -1.5 v-8 A1.5 1.5 0 0 1 5 3.5 h8 A1.5 1.5 0 0 1 14.5 5 v0.5",
  gear: "M12 15 a3 3 0 1 0 0 -6 a3 3 0 0 0 0 6|M12 3.5 v2.2|M12 18.3 v2.2|M20.5 12 h-2.2|M5.7 12 H3.5|M18 6 l-1.6 1.6|M7.6 16.4 L6 18|M18 18 l-1.6 -1.6|M7.6 7.6 L6 6",
  out: "M14 5.5 H8 A1.5 1.5 0 0 0 6.5 7 v10 A1.5 1.5 0 0 0 8 18.5 h6|M11 12 h9.5|M17.5 9 L20.5 12 L17.5 15",
  mail: "M4 6.5 h16 v11 H4 Z|M4.5 7.5 L12 13 L19.5 7.5",
  doc: "M7 3.5 h7 L18.5 8 V20.5 h-11.5 Z|M14 3.5 V8 h4.5",
  down: "M12 4 v11|M7 10.5 L12 15.5 L17 10.5|M5 19.5 h14",
  check: "M5 12.5 L10 17.5 L19 7",
  task: "M5 7 l1.6 1.6 L9.5 5.7|M12.5 7.2 h7|M5 13 l1.6 1.6 L9.5 11.7|M12.5 13.2 h7|M5 19 l1.6 1.6 L9.5 17.7|M12.5 19.2 h7",
  qr: "M4 4 h6 v6 H4 Z|M6 6 h2 v2 H6 Z|M14 4 h6 v6 h-6 Z|M16 6 h2 v2 h-2 Z|M4 14 h6 v6 H4 Z|M6 16 h2 v2 H6 Z|M14 14 h3 v3 h-3|M20 14 v3|M17 20 h3|M14 20 v-1.5",
  pen: "M16.8 4.4 a2 2 0 0 1 2.8 2.8 L8.4 18.4 L4.6 19.4 L5.6 15.6 Z",
  trash: "M5 7 h14|M9.5 7 V5.4 a1.4 1.4 0 0 1 1.4 -1.4 h2.2 a1.4 1.4 0 0 1 1.4 1.4 V7|M6.8 7 l0.7 12 a1.6 1.6 0 0 0 1.6 1.5 h5.8 a1.6 1.6 0 0 0 1.6 -1.5 L17.2 7|M10.3 10.5 v6|M13.7 10.5 v6",
  // KV2-§8 additions (same 1.7px-stroke language): hamburger (§8.3 history),
  // plus (§8.3 new chat / §8.4 zoom in), minus (§8.4 zoom out).
  menu: "M4 6.5 h16|M4 12 h16|M4 17.5 h16",
  plus: "M12 5.5 v13|M5.5 12 h13",
  minus: "M5.5 12 h13",
};

export interface GlyphProps {
  d: string;
  size?: number;
  fill?: boolean;
  vb?: string;
  style?: React.CSSProperties;
}

export function Glyph({ d, size = 18, fill = false, vb = "0 0 24 24", style }: GlyphProps) {
  return (
    <svg
      viewBox={vb}
      width={size}
      height={size}
      fill={fill ? "currentColor" : "none"}
      stroke={fill ? "none" : "currentColor"}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0, ...style }}
    >
      {d.split("|").map((p, i) => (
        <path key={i} d={p} />
      ))}
    </svg>
  );
}

export interface SparkProps {
  size?: number;
  style?: React.CSSProperties;
}

export function Spark({ size = 16, style }: SparkProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" style={{ flexShrink: 0, ...style }}>
      <path d="M12 2.8 L14.1 9.9 L21.2 12 L14.1 14.1 L12 21.2 L9.9 14.1 L2.8 12 L9.9 9.9 Z" />
    </svg>
  );
}
